import { makeStyles, Theme } from '@material-ui/core/styles'

/**
 * Styles for ClashWarningDialog component
 * Provides dialog title, content, and icon styling
 */
export const useClashWarningDialogStyles = makeStyles((theme: Theme) => ({
    titleBox: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    warningIcon: {
        color: theme.palette.error.main,
        fontSize: 32,
    },
    content: {
        paddingTop: theme.spacing(2),
    },
}))

/**
 * Styles for BPApplicationLoadingScreen component
 * Provides loading dialog, progress bar, and message styling
 */
export const useBPApplicationLoadingStyles = makeStyles((theme: Theme) => ({
    dialogContent: {
        padding: theme.spacing(4),
        textAlign: 'center',
        minWidth: 400,
    },
    titleBox: {
        marginBottom: theme.spacing(3),
    },
    progressBox: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2),
    },
    progressBar: {
        height: 10,
        borderRadius: 5,
    },
    percentageText: {
        marginTop: theme.spacing(1),
        fontWeight: 600,
        fontSize: '1.2rem',
        color: theme.palette.primary.main,
    },
    messageText: {
        marginTop: theme.spacing(2),
        color: theme.palette.text.secondary,
    },
    spinner: {
        marginTop: theme.spacing(2),
    },
}))
